var map = {
	"./Sonar-dark.svg": 95066,
	"./Sonar.svg": 85860,
	"./ada-dark.svg": 79014,
	"./ada.svg": 4766,
	"./analysis.png": 90877,
	"./assembly.png": 40944,
	"./c++.svg": 36611,
	"./c.svg": 89723,
	"./circt.svg": 18537,
	"./clean.svg": 9711,
	"./cmake.svg": 19530,
	"./crystal-dark.svg": 65844,
	"./crystal.svg": 86643,
	"./cuda-dark.svg": 56397,
	"./cuda.svg": 82912,
	"./d.svg": 75779,
	"./dart.svg": 33725,
	"./dotnet.svg": 62130,
	"./erlang.svg": 71217,
	"./fortran.svg": 18218,
	"./fsharp.svg": 52583,
	"./go.svg": 16593,
	"./haskell.png": 34524,
	"./hlsl.png": 86137,
	"./hook.png": 44607,
	"./ispc.png": 94634,
	"./java.svg": 96199,
	"./julia.svg": 92117,
	"./kotlin.svg": 23519,
	"./llvm.png": 42722,
	"./mlir.svg": 45102,
	"./nim.svg": 5961,
	"./ocaml.svg": 6130,
	"./opencl-dark.svg": 97589,
	"./opencl.svg": 10555,
	"./pascal-dark.svg": 50636,
	"./pascal.svg": 7943,
	"./pony.svg": 82241,
	"./python.svg": 45380,
	"./racket.svg": 34882,
	"./ruby.svg": 94621,
	"./rust-dark.svg": 72066,
	"./rust.svg": 85545,
	"./scala.png": 12209,
	"./solidity.svg": 42018,
	"./swift.svg": 59935,
	"./toit.svg": 52788,
	"./ts.svg": 19345,
	"./zig.svg": 60283
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48933;